import {WidgetType} from '@codemirror/view'

import styles from './drop-indicator.module.css'

/**
 * Simple widget that renders the drop position indicator.
 */
export class DropIndicatorWidget extends WidgetType {
  override toDOM() {
    const indicator = document.createElement('div')
    indicator.className = styles.dropIndicator || ''
    return indicator
  }

  override eq() {
    // All drop indicator widgets are identical
    return true
  }

  override ignoreEvent() {
    return true
  }
}
